<template>
  <div class="test-exercise">
    <div class="toolbar">
      <el-select v-model="searchLevel" placeholder="等级" :clearable="true" style="width:100px;margin-right:8px;">
        <el-option
          v-for="item in $store.state.levels"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="searchDiff" placeholder="难度" :clearable="true" style="width:120px;margin-right:8px;">
        <el-option label="难度1(简单)" value="1"></el-option>
        <el-option label="难度2(复杂)" value="2"></el-option>
      </el-select>
      <el-select v-model="searchStatus" placeholder="状态" :clearable="true" style="width:100px;margin-right:8px;">
        <el-option label="已激活" value="1"></el-option>
        <el-option label="已禁用" value="0"></el-option>
      </el-select>
      <el-input v-model="search" placeholder="搜索题目" style="width:200px;margin-right:8px;"/>
      <el-input v-model="searchKnows" placeholder="搜索知识点" style="width:100px;margin-right:8px;"/>
      <el-checkbox v-model="searchDeleted" label="查看已删除的题目" border style="margin-right:8px;"></el-checkbox>
      <el-button @click="fetchData" icon="el-icon-refresh"></el-button>
      <el-button @click="createExercise" type="primary" >添加题目</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @sort-change="handleSort"
    >
      <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
      <el-table-column prop="level" label="等级" sortable="custom" width="80"></el-table-column>
      <el-table-column prop="difficulty" label="难度" width="70">
        <template #default="column">
          <div class="diff-wrap" @click="switchDiff(column.row)">
            <span :class="'diff' + column.row.difficulty">{{column.row.difficulty}}</span>
            <i class="el-icon-d-caret"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="知识点" width="150">
        <template v-slot="column">
          <span class="knowl" v-for="item in column.row.exercise.knows" :key="item.id">{{item.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="题目">
        <template v-slot="column">
          <ExercisePreview :entity="column.row.exercise"></ExercisePreview>
        </template>
      </el-table-column>
      <el-table-column label="启用" width="55">
        <template v-slot="column">
          <el-checkbox v-model="column.row.status" :true-label="1" :false-label="0" @change="handleStatusChange(column.row)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="updateExercise(scope.row)" type="text" size="medium">修改</el-button>
          <el-button v-if="scope.row.deleted===0" @click="handleDelete(scope.row)" type="text" size="medium">删除</el-button>
          <el-button v-if="scope.row.deleted===1" @click="handleRestore(scope.row)" type="text" size="medium">还原</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <ExerciseForm ref="exrform"></ExerciseForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleExerciseSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ExercisePreview from '@/components/exercise/ExercisePreview'
import ExerciseForm from '@/components/exercise/ExerciseForm'

export default {
  name: 'TestExercise',
  components: {ExercisePreview, ExerciseForm},
  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      sort: '-id',
      searchLevel: null,
      searchDiff: null,
      searchKnows: null,
      search: null,
      searchDeleted: null,
      searchStatus: null,
      dialogTitle: '修改题目',
      dialogVisible: false,
    }
  },
  props: {
    type: String
  },
  created () {
    this.fetchData()
  },
  watch: {
    type () {
      this.fetchData()
    },
    searchLevel () {
      this.fetchData()
    },
    searchDiff () {
      this.fetchData()
    },
    searchKnows () {
      this.fetchData()
    },
    search () {
      this.fetchData()
    },
    searchDeleted () {
      this.fetchData()
    },
    searchStatus () {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.$http.get(this.$urls.test_exercise_list, {
        params: {
          page: this.currentPage,
          'per-page': this.pageSize,
          type: this.type,
          sort: this.sort,
          level: this.searchLevel,
          difficulty: this.searchDiff,
          search: this.search,
          knowl: this.searchKnows,
          deleted: this.searchDeleted ? 1 : null,
          status: this.searchStatus
        }
      }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.tableData = res.data
      })
    },
    handleSort ({column, prop, order}) {
      this.sort = order === 'ascending' ? prop : ('-' + prop)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleUpdate (item, values, opts) {
      let notify = Object.assign({
        message: '操作',
        doneType: 'success',
        doneTitle: '成功',
        failType: 'error',
        failTitle: '失败',
      }, typeof opts === 'string' ? { message: opts } : opts)
      return this.$http.put(this.$urls.test_exercise_update, values, {
        params: {id: item.id}
      }).then((data) => {
        this.$notify({
          title: notify.doneTitle,
          message: notify.doneMessage || `${notify.message}成功`,
          type: notify.doneType
        })
        return data
      }).catch(error => {
        this.$notify({
          title: notify.failTitle,
          message: notify.failMessage || `${notify.message}失败`,
          type: notify.failType
        })
        return error
      })
    },
    handleDelete(item) {
      this.handleUpdate(item, {deleted: 1}, {
        message: `ID: ${item.id} 的题目删除`,
        doneType: 'warning'
      }).then(this.fetchData)
    },
    handleRestore(item) {
      this.handleUpdate(item, {deleted: 0}, `ID: ${item.id} 的题目还原`).then(this.fetchData)
    },
    handleStatusChange(item) {
      this.handleUpdate(item, {status: item.status}, {
        message: `ID: ${item.id} 的题目${item.status === 1 ? '启用' : '禁用'}`, 
        doneType: item.status === 1 ? 'success' : 'warning'
      }).then(data => {
        data.data.status === item.status || (item.status = data.data.status)
      }).catch(error => {
        item.status = item.status === 1 ? 0 : 1
      })
    },
    switchDiff(item) {
      let diff = item.difficulty === 1 ? 2 : 1
      item.difficulty = diff
      this.handleUpdate(item, {difficulty: diff}, `ID: ${item.id} 的题目改为难度${diff}`)
    },
    createExercise () {
      this.dialogVisible = true
      this.dialogTitle = '添加题目'
      window.setTimeout(() => {
        if (this.$refs.exrform.model.id) {
          this.$refs.exrform.reset({level: this.searchLevel})
        } else if(!this.$refs.exrform.model.level) {
          this.$refs.exrform.model.level = this.searchLevel
        }
      }, 10)
    },
    updateExercise (item) {
      this.dialogVisible = true
      this.dialogTitle = '修改题目'
      window.setTimeout(() => {
        this.$refs.exrform.reset(item.exercise)
      }, 10)
    },
    handleExerciseSubmit () {
      let isAdd = !this.$refs.exrform.model.id
      this.$refs.exrform.submit().then(res => {
        this.dialogVisible = false
        if (isAdd) {
          this.$http.post(this.$urls.test_exercise_create, {
            exercise_id: res.data.id,
            level: this.$refs.exrform.model.level,
            type: this.type,
            difficulty: this.difficulty || 1,
            status: 1, 
            deleted: 0
          }).then(data => {
            this.$notify({
              title: '成功',
              message: '添加题目并关联成功',
              type: 'success'
            })
            this.fetchData()
          })
        } else {
          this.$notify({
            title: '成功',
            message: '修改题目成功',
            type: 'success'
          })
          this.fetchData()
        }
        this.$refs.exrform.reset()
      })
    },
  }
}
</script>

<style lang="scss">
.test-exercise{
  .el-table{
    font-size: 16px;
  }
  .diff-wrap{
    display: inline-block;
    cursor: pointer;
    >span{
      padding-right: 3px;
    }
    &:hover{
      text-decoration: underline;
    }
  }
  .diff1{
    color: #409EFF;
  }
  .diff2{
    color: #E6A23C;
  }
  .knowl{
    padding-right: 3px;
    &:last-child{
      padding-right: 0;
    }
  }
}
</style>